// extracted by mini-css-extract-plugin
module.exports = {"article":"JoinUsPage_article__k3ENh"};